export default __webpack_public_path__ + "static/media/ragno.90275593.png";